export const DEFAULT_ATTRS: Attrs = {
	enabled: false,
	propertyId: '',
	propertyName: '',
};

export type Attrs = {
	readonly enabled: boolean;
	readonly propertyId: string;
	readonly propertyName: string;
};

export type SetAttrs = ( attrs: Partial< Attrs > ) => void;

// ============
// HELPER TYPES
// ============

export type GA4Property = {
	readonly id: string;
	readonly name: string;
};

export type ConnectionMode =
	| 'init'
	| 'awaiting-authorization'
	| 'property-retrieval'
	| 'property-selection'
	| 'ga4-property-id';
